import { Chip, Tooltip, makeStyles } from '@material-ui/core';
import type { Role } from '../../api/types';
import { ROLE_LABELS } from '../../api/types';

const ROLE_COLORS: Record<Role, { bg: string; text: string }> = {
  admin: { bg: '#D32F2F', text: '#FFFFFF' },
  gestor: { bg: '#201547', text: '#FFFFFF' },
  analista: { bg: '#0288D1', text: '#FFFFFF' },
  desenvolvedor: { bg: '#2E7D32', text: '#FFFFFF' },
  revisor: { bg: '#F9A825', text: '#000000' },
  aprovador: { bg: '#7B1FA2', text: '#FFFFFF' },
  observador: { bg: '#D9D9D6', text: '#333333' },
};

const ROLE_DESCRIPTIONS: Record<Role, string> = {
  admin: 'Acesso total ao Spassu Code',
  gestor: 'Gerencia membros e supervisiona o pipeline do projeto',
  analista: 'Cria e gerencia Work Items no backlog para os desenvolvedores',
  desenvolvedor: 'Cria e executa activities no projeto',
  revisor: 'Revisa artefatos e código gerado',
  aprovador: 'Aprova transições de fases críticas',
  observador: 'Acesso somente leitura para auditoria',
};

const useStyles = makeStyles(() => ({
  chip: {
    fontWeight: 600,
    fontSize: '0.75rem',
    height: 24,
  },
}));

export interface RoleBadgeProps {
  role: Role;
  size?: 'small' | 'medium';
}

export const RoleBadge = ({ role, size = 'small' }: RoleBadgeProps) => {
  const classes = useStyles();
  const colors = ROLE_COLORS[role] ?? ROLE_COLORS.observador;

  return (
    <Tooltip title={ROLE_DESCRIPTIONS[role] ?? role} arrow>
      <Chip
        label={ROLE_LABELS[role] ?? role}
        size={size}
        className={classes.chip}
        style={{ backgroundColor: colors.bg, color: colors.text }}
      />
    </Tooltip>
  );
};
